import { createSlice } from '@reduxjs/toolkit';
import { toast } from '@/ui/toast';
import { KToast } from '@/ui-library/components/organisms/KToast/KToast';
const statusMapping = {
  success: 'success',
  notice: 'info',
  alert: 'warning',
  error: 'error',
};

const durationMapping = {
  success: 3000,
  info: 5000,
  warning: 7500,
  error: 10000, // give users more time to read important messages
};

export const { actions, reducer } = createSlice({
  name: 'flash',
  initialState: {},
  reducers: {
    setFlash(_state, { payload }) {
      for (const type in payload) {
        const status = statusMapping[type] || 'success';
        const duration = durationMapping[status];
        const messages = payload[type];
        for (const [text] of messages) {
          toast({
            description: text,
            status: status,
            position: 'top',
            duration: duration,
            isClosable: true,
            render: ({ id }) => (
              <KToast
                props={{ description: text }}
                status={status}
                duration={duration}
                onClose={() => toast.close(id)}
              />
            ),
          });
        }
      }
      return payload;
      // NOTE:
      // Only the last flash payload is tracked in the store (for reference only, not actually used elsewhere for now)
      // In the future, we may instead want to keep a history of flash messages,
      // e.g. to show past messages, in case the user missed it
    },
  },
});

export const { setFlash } = actions;

export default reducer;
